const basicOptions = [
  {
    label: "Yes",
    value: "yes",
    checked: false,
  },
  {
    label: "No",
    value: "no",
    checked: false,
  },
];

const getCheckedIndex = (index: 0 | 1) => {
  let newOptions = [...basicOptions];
  newOptions[index].checked = true;
  return newOptions;
};

const getOnlyIndex = (index: 0 | 1) => {
  return [basicOptions[index]];
};

const getYesNoOptions = ({ checked, only }: { checked?: "yes" | "no"; only?: "yes" | "no" }) => {
  if (only) {
    if (only === "yes") return getOnlyIndex(0);
    else return getOnlyIndex(1);
  } else if (!checked) return basicOptions;
  else if (checked === "yes") return getCheckedIndex(0);
  else return getCheckedIndex(1);
};

export default getYesNoOptions;
